import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const userImprintCapabilitiesIndustrysAdapter = createEntityAdapter({})

const initialState = userImprintCapabilitiesIndustrysAdapter.getInitialState()

export const userImprintCapabilitiesIndustrysApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserImprintCapabilitiesIndustrys: builder.query({
            query: () => ({
                url: '/userImprintCapabilitiesIndustrys/getUserImprintCapabilitiesIndustrys',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedUserImprintCapabilitiesIndustrys = responseData.map(userImprintCapabilitiesIndustry => {
                    userImprintCapabilitiesIndustry.id = userImprintCapabilitiesIndustry._id
                    return userImprintCapabilitiesIndustry
                })
                return userImprintCapabilitiesIndustrysAdapter.setAll(initialState, loadedUserImprintCapabilitiesIndustrys)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'UserImprintCapabilitiesIndustry', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'UserImprintCapabilitiesIndustry', id}))
                    ]
                } else {
                    return [ { type: 'UserImprintCapabilitiesIndustry', id: 'LIST'}]
                }
            },
        }),
        createNewUserImprintCapabilitiesIndustry: builder.mutation({
            query: initialUserImprintCapabilitiesIndustry => ({
                url: '/userImprintCapabilitiesIndustrys/createNewUserImprintCapabilitiesIndustry',
                method: 'POST',
                body: {...initialUserImprintCapabilitiesIndustry,}
            }),
            invalidatesTags: [
                { type: 'UserImprintCapabilitiesIndustry', id: "LIST" }
            ] 
        }),
        updateUserImprintCapabilitiesIndustry: builder.mutation({
            query: initialUserImprintCapabilitiesIndustry => ({
                url: '/userImprintCapabilitiesIndustrys/updateUserImprintCapabilitiesIndustry',
                method: 'PATCH',
                body: {...initialUserImprintCapabilitiesIndustry,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'UserImprintCapabilitiesIndustry', id: arg.id },
                { type: 'UserImprintCapabilitiesIndustry', id: 'LIST' }
            ],
        }),
        deleteUserImprintCapabilitiesIndustry: builder.mutation({
            query: ({id}) => ({
                url: '/userImprintCapabilitiesIndustrys/deleteUserImprintCapabilitiesIndustry',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserImprintCapabilitiesIndustry', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetUserImprintCapabilitiesIndustrysQuery,
    useCreateNewUserImprintCapabilitiesIndustryMutation,
    useUpdateUserImprintCapabilitiesIndustryMutation,
    useDeleteUserImprintCapabilitiesIndustryMutation,
} = userImprintCapabilitiesIndustrysApiSlice

// returns the query result object
export const selectUserImprintCapabilitiesIndustryResult = userImprintCapabilitiesIndustrysApiSlice.endpoints.getUserImprintCapabilitiesIndustrys.select()

// create memoized selector
const selectUserImprintCapabilitiesIndustrysData = createSelector(
    selectUserImprintCapabilitiesIndustryResult,
    userImprintCapabilitiesIndustryResult => userImprintCapabilitiesIndustryResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserImprintCapabilitiesIndustrys,
    selectById: selectUserImprintCapabilitiesIndustryById,
    selectIds: selectUserImprintCapabilitiesIndustryIds,
} = userImprintCapabilitiesIndustrysAdapter.getSelectors(state => selectUserImprintCapabilitiesIndustrysData(state) ?? initialState)